import { Injectable } from '@angular/core';
import { CulturalRoute } from '../../../dtos/culturalRoute';
import { ApiConfigService } from '../../../shared-services/api-config.service';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { CulturalRouteVo } from '../../../vo/culturalRouteVo';

@Injectable({
  providedIn: 'root'
})
export class CulturalRouteService {

  constructor(private apiConfigService:ApiConfigService) { }

  getCulturalRoutes(filters?){
    return this.apiConfigService.get<CulturalRoute[]>('api/culture-routes/search', filters).pipe(
        map((results:CulturalRoute[])=> results.map(CulturalRouteService.convertRouteDtoToRouteVo))
    );
  }

  getAttributes(){
      return this.apiConfigService.get('api/attributes/get-all');
  }

  getCities(){
      return this.apiConfigService.get('api/attributes/get-cities');
  }

  private static convertRouteDtoToRouteVo(route: CulturalRoute): CulturalRouteVo{
      const routeVo = new CulturalRouteVo();
      return <CulturalRouteVo>Object.assign(routeVo, route);
  }
}
